// extracted by mini-css-extract-plugin
export default {"header":"DashboardHeader_header__AgfJn","dropdown_content":"DashboardHeader_dropdown_content__VzaFT"};